// Фича-флаги фронтенда. Выключенные разделы не попадают в роутер.
// TODO(pipeline): orders включить после реальной интеграции заказов —
// текущая страница Orders показывает мок-данные (см. docs/PIPELINE_REFACTORING_PLAN.md, Волна 0).
export const FEATURES = {
  orders: false,
  /** Admin-only beta; backend repeats the same role and permission gates. */
  layoutGenerator: true,
  /**
   * Студия контент-воронок v2 (docs/SPEC_2026-09-22_CONTENT_FUNNEL_STUDIO_UX_V2.md).
   * Управляет только тем, какая страница отвечает за `/content-funnel-studio`
   * для НОВЫХ проектов; уже созданные v1-проекты продолжают открываться по
   * старым ссылкам независимо от этого флага (см. StudioProjectRoute).
   */
  contentFunnelStudioV2: true,
} as const
